import { Game } from "@/models/game";
import { EnergySource } from "@/models/energy-source";
import { NotificationItem } from "@/models/notification";
import { AIPlayer } from "@/models/ai-player";
import { FinesEvent, NoFinesEvent } from "@/models/events";
import { History } from "@/models/history"
import { Inventory, getTotalEnergy, getProfit } from "@/models/inventory"
import moment from "moment";

function historyAddItem(history: History, item: EnergySource, amount: number, roundNumber: number) {
    if (!history.history[roundNumber - 1]) { history.history[roundNumber - 1] = new Map<EnergySource, number>() }
    const foo = history.history[roundNumber - 1].get(item)
    if (foo != null) {
        history.history[roundNumber - 1].set(item, foo + amount)
    } else {
        history.history[roundNumber - 1].set(item, amount)
    }
}

function inventoryAddItem(inventory: Inventory, item: EnergySource, amount: number) {
    let foo = inventory.energySources.get(item)
    if (foo == null) {
        foo = []
    }
    for (let i = 0; i < amount; i++) {
        foo.push({ isBuilt: item.timeToBuild === -1, age: 0, timeToBuild: item.timeToBuild })
    }
    inventory.energySources.set(item, foo);
    inventory.inventoryChangeNum += 1
}

export default {
    OVERVIEW_OVER(state: Game) {
        state.showOverview = false
    },
    BEGIN_TUTORIAL(state: Game) {
        state.tutorial = true
        state.tutorialIndex = 0
    },
    END_TUTORIAL(state: Game) {
        state.tutorial = false
    },
    INSTRUCTIONS_OVER(state: Game) {
        state.firstLoad = false
    },
    INSTRUCTIONS_REDO(state: Game) {
        state.firstLoad = true
    },
    TOGGLE_BOOK(state: Game) {
        state.showBook = !state.showBook
    },
    START_GAME(state: Game) {
        state.introScreen = false
    },
    DISMISS_EVENT(state: Game, commit: any) {
        if (state.rounds != null) {
            let round = state.rounds[state.activeRound - 1]
            round.events.shift();
            if (round.events.length == 0 && round.ended && state.rounds.length == state.activeRound) {
                if (state.money <= 0 || state.pollution > state.pollutionThreshold) {
                    state.playerLost = true;
                } else {
                    state.gameOver = true;
                }

                // state.timer = 0;
            } else if (round.events.length === 0 && round.ended) {
                if (state.money <= 0 || state.pollution > state.pollutionThreshold) {
                    state.playerLost = true;
                }
                state.activeRound++;
                state.playerEnergy = getTotalEnergy(state);
                state.money += getProfit(state);
            }
        }
    },
    MOD_GAME_SPEED(state: Game, { increasing, SPEEDS }: { increasing: boolean, SPEEDS: [] }) {
        if (increasing && state.roundSpeed < SPEEDS.length - 1) {
            state.roundSpeed++
        } else if (!increasing && state.roundSpeed <= SPEEDS.length - 1 && state.roundSpeed > 0) {
            state.roundSpeed--
        }
    },
    async RETRIEVE_MARKDOWN(state: Game, data: any) {
        state.rounds = await data;
    },
    POPUP(state: Game, bool: boolean) {
        state.popup = bool
    },
    END_ROUND(state: Game) {
        state.rounds![state.activeRound - 1].endRound()
        // state.showOverview = true
    },
    OVERVIEW_START(state: Game) {
        state.showOverview = true
    },
    SET_MIN_MWATTS(state: Game, mwatts: number) {
        state.minMwatts = mwatts
    },
    SELECT_ELEMENT(state: Game, element: EnergySource) {
        state.selectedEnergySource = element
    },
    CHANGE_TIMER(state: Game, deltaTime: number) {
        // state.timeVal += deltaTime;
        const obj = moment(state.timeVal).utc()
        state.timeStr = obj.add(1, "minute").format("HH:mm")
        state.timeVal = obj.valueOf()
        state.minsSinceMidnight = obj.diff(obj.clone().startOf("day"), "minutes")
    },
    SET_PRICE(state: Game, payload: { id: number, price: number }) {
        state.energySources[payload.id].price = payload.price
    },
    SET_AMOUNT(state: Game, payload: { id: number, amount: number }) {
        state.energySources[payload.id].units = state.energySources[payload.id].unitCap = payload.amount
    },
    SET_TIMER(state: Game, timeval: number) {
        state.timeVal = timeval
        if (state.timeVal === null) {
            state.timeStr = null
        }
        state.minsSinceMidnight = 0
    },
    EDIT_MONEY(state: Game, money: number) {
        state.money += money
    },
    SET_ROUND_ACTIVE(state: Game) {
        state.roundActive = true
    },
    SET_ROUND_INACTIVE(state: Game) {
        state.roundActive = false
    },
    RESET_ENERGY(state: Game) {
        state.playerEnergy = 0
    },
    NEXT_DAY(state: Game) {
        state.totalDays++
        state.rounds![state.activeRound - 1].day++
        for (const source of state.energySources) {
            source.oldUnits = source.units = source.unitCap
            source.oldPrice = source.price
        }
    },
    CALCULATE_EARNINGS(state: Game) {
        // The player energy after the round will be much more complex.
        // Add a method in the game state to determine what units the player
        // has in their inventory. Each unit should have an 'age' variable and
        // should be deleted from the player's inventory once the age is up.

        // We can use the EnergySource objects to maintain this data
        state.playerEnergy = getTotalEnergy(state)
        state.money += getProfit(state)

    },
    TOGGLE_MUTE(state: Game) {
        state.muted = !state.muted
    },
    CPU_ACTED(state: Game, payload: { cpu: AIPlayer, element: EnergySource }) {
        const index = state.aiPlayers.indexOf(payload.cpu)
        state.aiPlayers[index].timeActed = Date.now()
        inventoryAddItem(state.aiPlayers[index].inventory, payload.element, 1)
        // state.aiPlayers[index].inventory.addItem(payload.element, 1)
        historyAddItem(state.aiPlayers[index].history, payload.element, 1, state.activeRound)
        // state.aiPlayers[index].history.addItem(payload.element, 1, state.activeRound)
        state.notifications.unshift(new NotificationItem(`Player ${payload.cpu.id} Purchase`, `Player ${payload.cpu.id} has purchased ${1} of ${payload.element.name}.`))
    },
    USER_PURCHASE(state: Game, payload: { item: EnergySource, amount: number }) {
        const totalPrice = payload.item.price * payload.amount
        inventoryAddItem(state.inventory, payload.item, payload.amount)
        // state.inventory.addItem(payload.item, payload.amount)
        historyAddItem(state.history, payload.item, payload.amount, state.activeRound)
        // state.history.addItem(payload.item, payload.amount, state.activeRound)
        state.money -= totalPrice
        if (payload.item.timeToBuild === -1) {
            state.playerEnergy += payload.item.mwatts * payload.amount
        }
    },
    POLLUTE(state: Game, amount: number) {
        state.pollution += amount
    },
    PAUSE(state: Game) {
        state.paused = true
    },
    UNPAUSE(state: Game) {
        state.paused = false
    },
    EDIT_STOCK(state: Game, payload: { item: EnergySource, amount: number }) {
        const source = state.energySources.indexOf(payload.item)
        state.energySources[source].units -= payload.amount
    },
    NEW_NOTIFICATION(state: Game, notification: NotificationItem) {
        state.notifications.unshift(notification)
    },
    PROCESS_FINES(state: Game, payload: { history: string, mwatts: number, minMwatts: number, fines: boolean, fine: number }) {
        if (payload.fines) {
            state.rounds![state.activeRound - 1].addEvent(new FinesEvent([String(payload.minMwatts), String(payload.fine), payload.history], payload.fine))
        } else {
            state.rounds![state.activeRound - 1].addEvent(new NoFinesEvent([String(payload.minMwatts), payload.history]))
        }

    },
    SET_TUTORIAL_INDEX(state: Game, payload: number) {
        state.tutorialIndex = payload
    }
}
